import { useState, useSyncExternalStore } from 'react';
import { getPurchaseStatus, subscribePurchaseStatus } from '../../native/iap';
import { useT } from '../../i18n';
import { Button } from '../../components/ui';

export function PurchaseStatusNotice() {
  const { t } = useT();
  const status = useSyncExternalStore(subscribePurchaseStatus, getPurchaseStatus);
  const [dismissed, setDismissed] = useState<object | null>(null);
  if (status.state === 'idle' || dismissed === status) return null;
  return <section role="status" aria-live="polite">
    <p>{t(`iap.status.${status.state}`)}</p>
    <Button variant="ghost" onClick={() => setDismissed(status)}>{t('promo.dismiss')}</Button>
  </section>;
}
